import { useSnapshot } from 'valtio';
import { audioDevicesState } from './audioDevicesState';

export const useAudioDevices = () => useSnapshot(audioDevicesState);
